import * as Types from "../actionTypes/mediaStreamTypes";

const initialState = {
  video: false,
  audio: false,
  sound: false,
  videoLabel: false,
  videoStream: false,
  screenStream: false,
  recordPlay: false,
};

const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_DEVICE_VIDEO:
      return {
        ...state,
        video: action.payload,
      };
    case Types.SET_DEVICE_AUDIO:
      return {
        ...state,
        audio: action.payload,
      };
    case Types.SET_DEVICE_SCREEN_STREAM:
      return {
        ...state,
        screenStream: action.payload,
      };
    case Types.SET_DEVICE_CAM_STREAM:
      return {
        ...state,
        videoStream: action.payload,
      };
    case Types.SET_DEVICE_INIT:
      return initialState;
    default:
      return state;
  }
};

export default deviceReducer;
